module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p15"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "src": "images/img2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t8"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("So many things about a person can easily be changed: hair color, religious beliefs, political views, education, job, and the clothes they wear. Man has free will. Men can decide to be good men or bad men or something in between. Whether to have children, marry, fight, or walk away, the options are innumerable. But no matter how many changes we make, masks we wear, we cannot change nor hide from what we are at our core—our true selves. Sure, appetites can be subdued, but desire cannot be eradicated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("For too long, I tried to live a life being someone I wasn’t, but I now realize I wasn’t living. I was existing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Tek Cain")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c898150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013.vue
// module id = 90
// module chunks = 0